import { timestamp } from '../../utils';
import { onsiteSearchData } from '../tracking-constants';
import { OnSiteSearch, OnSiteSearchEvent } from '../types';

export const onsiteSearch = (data: OnSiteSearch): OnSiteSearchEvent => ({
  event: 'onsiteSearch',
  timestamp: timestamp(),
  content: {
    onsiteSearch: onsiteSearchData(data),
  },
});
